/** Mirror of src/utils/canonicalProductId.ts for admin deep-links. */

function normalizeForCanonicalId(brand: string, sku: string): { brand: string; sku: string } {
  return {
    brand: brand.toLowerCase().replace(/[^a-z0-9]/g, ''),
    sku: sku.replace(/[^a-zA-Z0-9]/g, ''),
  };
}

export function generateCanonicalProductId(brand: string, sku: string): string {
  const { brand: b, sku: s } = normalizeForCanonicalId(brand, sku);
  return `${b}_${s}`;
}

export function canGenerateCanonicalProductId(brand: string, sku: string): boolean {
  const { brand: b, sku: s } = normalizeForCanonicalId(brand, sku);
  return b.length > 0 && s.length > 0;
}
